<template>
  <VBlock
    v-if="isVisible"
    :direction="Direction.column"
    :sort="Sort.left_center"
    :padding="[0, 15]"
    :margin="[7, 0, 0, 0]"
  >
    <VCard class="cart-free-gift" :radius="4">
      <div v-for="(gift, index) in freeGifts" :key="index">
        <VBlock v-if="gift.isVisible()" :direction="Direction.column">
          <VBlock :padding="[14, 15, 14]" :sort="Sort.space_between">
            <VBlock class="left" :sort="Sort.left_center">
              <VBlock class="dot-wrapper">
                <div class="dot"></div>
              </VBlock>
              <VP
                class="text"
                :text="gift.getItemName()"
                :size="14"
                :spacing="-0.35"
                :color="TextColor.gray2"
              />
            </VBlock>
            <VBlock class="right">
              <VP
                class="text"
                :text="`${gift.getNowCount()}개 증정`"
                :size="14"
                :spacing="-0.35"
                :color="gift.getOverflow() ? TextColor.emergency : TextColor.gray2"
              />
            </VBlock>
          </VBlock>
          <hr v-if="index < freeGifts.length - 1" class="hr" />
        </VBlock>
      </div>
    </VCard>
    <VBlock v-if="isOverLimit" class="emergency" :sort="Sort.left_top" :padding="[8, 10]">
      <VImage class="icon" :width="14" :height="14" :src="resources.EmergencyIcon" />
      <VP
        class="text"
        text="증정품 수량이 부족하여, 한정된 수량으로 제공됩니다."
        :spacing="-0.37"
        :size="12"
        :color="TextColor.emergency"
      />
    </VBlock>
  </VBlock>
</template>

<script>
import VP, { TextWeight, TextColor } from '@/presentationals/v2/components/layouts/atoms/VP'
import VImage from '@/presentationals/v2/components/layouts/atoms/VImage'

import VBlock, { Direction, Sort } from '@/presentationals/v2/components/layouts/molecules/VBlock'
import VCard from '@/presentationals/v2/components/layouts/molecules/VCard'

import EmergencyIcon from '@/assets/images/emergency-icon.svg'

export default {
  name: 'CartFreeGift',
  props: {
    freeGifts: {
      type: Array,
      required: true
    }
  },
  computed: {
    isOverLimit() {
      return this.freeGifts.some(gift => gift.getOverflow())
    },
    isVisible() {
      return this.freeGifts.filter(gift => gift.isVisible()).length > 0
    }
  },
  components: {
    VBlock,
    VCard,
    VP,
    VImage
  },
  data() {
    return {
      Direction,
      Sort,
      TextColor,
      TextWeight,

      resources: {
        EmergencyIcon
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.cart-free-gift {
  width: 100%;
  height: auto;
  background-color: $light-gray-8;

  .hr {
    border: none;
    width: calc(100% - 30px);
    margin: 0;
    // margin-bottom: -1px;

    height: 1px;
    background-image: linear-gradient(to right, $light-gray-4 20%, rgba(255, 255, 255, 0) 0%);
    background-position: bottom;
    background-size: 5px 2px; /*점선 간격 수정*/
    background-repeat: repeat-x;
  }

  .text {
    white-space: nowrap;
    height: auto;
  }

  .left {
    width: 70%;
    height: auto;

    .dot-wrapper {
      width: 3px;
      height: auto;
      margin-right: 4px;

      .dot {
        width: 3px;
        height: 3px;
        border-radius: 3px;
        background-color: $gray-2;
      }
    }

    .text {
      width: calc(100% - 0px);
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: left;
    }
  }

  .right {
    width: auto;

    .text {
      text-align: right;
    }
  }
}

.emergency {
  width: 100%;
  height: auto;
  position: relative;

  .icon {
    // width: 14px;
    // height: 14px;
    vertical-align: middle;
    margin-right: 4px;
  }

  .text {
    text-align: left;
    vertical-align: middle;
    line-height: 15px;
  }
}

@supports (-webkit-touch-callout: none) {
  /* CSS specific to iOS devices */
  .cart-free-gift {
    .text {
      margin-top: 2px;
    }
  }
}

@supports not (-webkit-touch-callout: none) {
  /* CSS for other than iOS devices */
  .cart-free-gift {
    .text {
      // margin-top: 1px;
    }
  }
}
</style>
